import React from 'react';
import PropTypes from 'prop-types';
import {
  Popover,
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  Card,
  IconButton
} from 'material-ui';
import ViewIcon from 'material-ui/svg-icons/action/zoom-in';
import CallsWidget from './CallsWidget';

class DataField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  _onOpen = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  _onClose = () => {
    this.setState({ open: false });
  };

  render() {
    const data = (this.props.record || {}).data || {};
    const calls = (this.props.record || {}).calls || [];
    const preview =
      Object.values(data)
        .filter(x => x)
        .join(', ')
        .substr(0, 100) + '...';
    return (
      <div>
        <div>
          <IconButton
            style={{
              // position: 'absolute',
              // marginTop: -50,
              // marginLeft: 'auto',
              // marginRight: 0
              float: 'right'
            }}
            onClick={this._onOpen}
          >
            <ViewIcon />
          </IconButton>
        </div>
        <span>{preview}</span>
        <Popover
          onRequestClose={this._onClose}
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          <Card style={{ height: 300 }}>
            <Table style={{ width: 600 }}>
              <TableBody displayRowCheckbox={false}>
                {Object.keys(data).map(key => (
                  <TableRow key={key}>
                    <TableRowColumn>{key}</TableRowColumn>
                    <TableRowColumn>{data[key]}</TableRowColumn>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div className="bootstrap">
              <CallsWidget value={calls} />
            </div>
          </Card>
        </Popover>
      </div>
    );
  }
}
DataField.propTypes = {
  record: PropTypes.shape({
    data: PropTypes.object
  })
};
DataField.defaultProps = { label: 'Data', record: { data: {} } };

export default DataField;



// WEBPACK FOOTER //
// ./src/components/DataField.js